<script setup lang="ts">
import { SENSOR_ALERT_BATTERY_LEVEL } from '@/services/consts/operation_office';
import SelectBox from '@/components/Common/selectBox.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

type keyValue = {
  key: string | number,
  value: string | number
}

const props = defineProps<{
  modelValue: keyValue;
  windowInnerWidth: number;
}>();

const emit = defineEmits(['update:modelValue']);
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})
</script>
<template>
  <v-row
    class="text-form pl-4 pr-3 mt-2 mb-4"
  >
    <v-col :cols="props.windowInnerWidth > 800 ? 2 : 3" />
    <v-col :cols="props.windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-3 pt-4">
        {{ i18n.global.t('pages.operationOffices.form.tdsensor.batteryAlert') }}
      </h6>
    </v-col>
    <v-col :cols="props.windowInnerWidth > 800 ? 2 : 3">
      <SelectBox
        v-model="modelValue"
        :items="SENSOR_ALERT_BATTERY_LEVEL"
        :clearable="false"
      />
    </v-col>
    <v-col :cols="props.windowInnerWidth > 800 ? 2 : 3">
      {{ i18n.global.t('pages.operationOffices.form.tdsensor.batteryAlertLabel') }}
    </v-col>
  </v-row>
</template>
